module.exports = __webpack_public_path__ + "img/fire.d9ea4aa6.png";